import React from "react";
import PropTypes from "prop-types";
import "../styles/components/Showroom.css";

const ShowroomFullscreen = ({ backgroundImage, classes, text }) => {
  return (
    <div
      className={`showroom showroom-full-screen`}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className={classes}>{text}</div>
    </div>
  );
};

ShowroomFullscreen.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  wrapperClasses: PropTypes.string,
  text: PropTypes.object
};

export default ShowroomFullscreen;
